<template>
  <AdminAccountPermissions v-if="isAdmin" />
  <UserManagement v-else />
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import AdminAccountPermissions from '@/components/AdminAccountPermissions.vue'
import UserManagement from '@/components/UserManagement.vue'

const store = useStore()
const isAdmin = computed(() => store.state.user?.user === 'admin')
</script>
